import { useParams } from "react-router-dom";
import { useApi } from "@/lib/useApi";
import { FestivalSidebar } from "@/components/FestivalSidebar";
import { FestivalSection } from "@/components/FestivalSection";
import { joinStyles } from "@/lib/format";

const autoplaySrc = (url) => {
  const sep = url.includes("?") ? "&" : "?";
  return url.includes("mediadelivery.net") ? `${url}${sep}autoplay=true` : `${url}${sep}autoplay=1`;
};

const Player = ({ video }) => (
  <div className="aspect-video rounded-2xl overflow-hidden bg-black shadow-[0_8px_30px_rgba(0,0,0,0.12)]" data-testid="video-player">
    {video.embed_url ? (
      <iframe
        key={video.id}
        src={autoplaySrc(video.embed_url)}
        title={video.title}
        className="w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
      />
    ) : (
      <div className="w-full h-full flex items-center justify-center text-white/70 text-sm">
        {video.status === "ready" ? "Video unavailable" : "This video is still processing — check back soon."}
      </div>
    )}
  </div>
);

export default function Watch() {
  const { id } = useParams();
  const { data: video, error } = useApi(`/videos/${id}`);

  if (error) {
    const status = error.response?.status;
    return (
      <div className="mt-24 text-center" data-testid="watch-error">
        <p className="text-[22px] font-bold">{status === 403 ? "This video is private" : "Video not found"}</p>
        <p className="mt-2 text-[15px] text-[#8A8A8A]">{status === 403 ? "Only logged-in admins can view it." : "It may have been removed or the link is incorrect."}</p>
      </div>
    );
  }
  if (!video) return null;
  const festival = video.festival;

  return (
    <div
      className={`mt-6 lg:mt-8 grid gap-6 lg:gap-10 ${
        festival
          ? "grid-cols-1 lg:grid-cols-[minmax(0,1fr)_300px] 2xl:grid-cols-[minmax(0,1fr)_340px]"
          : "grid-cols-1 max-w-[880px] 2xl:max-w-[1100px]"
      }`}
      data-testid="watch-page"
    >
      <div className="min-w-0 lg:col-start-1 lg:row-start-1">
        <Player video={video} />
        <h1 className="mt-4 text-[20px] md:text-[22px] lg:text-[24px] font-bold leading-tight" data-testid="watch-title">
          {video.title}
        </h1>
        {video.dance_styles?.length > 0 && (
          <p className="mt-1 text-[13px] md:text-[14px] font-medium text-[#8A8A8A]" data-testid="watch-styles">
            {joinStyles(video.dance_styles)}
          </p>
        )}
      </div>
      {festival && (
        <div className="hidden lg:block lg:col-start-2 lg:row-start-1 lg:row-span-2">
          <FestivalSidebar festival={festival} />
        </div>
      )}
      {festival && (
        <div className="min-w-0 lg:col-start-1 lg:row-start-2">
          <FestivalSection festival={festival} videoId={video.id} />
        </div>
      )}
    </div>
  );
}
